import React, { useState } from 'react';
import { Download, FileText, TrendingUp, Award } from 'lucide-react';

const ExamReport = () => {
  const [filters, setFilters] = useState({ exam_id: '', course_id: '' });

  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center">
        <div>
          <h1 className="text-2xl font-bold text-gray-900">Exam Report</h1>
          <p className="text-sm text-gray-500 mt-1">View comprehensive exam performance reports</p>
        </div>
        <button className="flex items-center gap-2 bg-green-600 text-white px-4 py-2 rounded-lg hover:bg-green-700">
          <Download className="h-4 w-4" />
          Export Report
        </button>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
        <div className="bg-white p-6 rounded-lg shadow">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm text-gray-500">Total Exams</p>
              <p className="text-3xl font-bold text-gray-900 mt-1">0</p>
            </div>
            <FileText className="h-12 w-12 text-blue-500" />
          </div>
        </div>
        <div className="bg-white p-6 rounded-lg shadow">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm text-gray-500">Average Score</p>
              <p className="text-3xl font-bold text-green-600 mt-1">0%</p>
            </div>
            <TrendingUp className="h-12 w-12 text-green-500" />
          </div>
        </div>
        <div className="bg-white p-6 rounded-lg shadow">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm text-gray-500">Pass Rate</p>
              <p className="text-3xl font-bold text-blue-600 mt-1">0%</p>
            </div>
            <Award className="h-12 w-12 text-blue-500" />
          </div>
        </div>
        <div className="bg-white p-6 rounded-lg shadow">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm text-gray-500">Top Performers</p>
              <p className="text-3xl font-bold text-purple-600 mt-1">0</p>
            </div>
            <Award className="h-12 w-12 text-purple-500" />
          </div>
        </div>
      </div>

      <div className="bg-white rounded-lg shadow p-4">
        <h3 className="text-lg font-semibold mb-4">Filters</h3>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">Exam</label>
            <select className="w-full px-3 py-2 border rounded-lg" value={filters.exam_id} onChange={(e) => setFilters({ ...filters, exam_id: e.target.value })}>
              <option value="">Select Exam</option>
            </select>
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">Course</label>
            <select className="w-full px-3 py-2 border rounded-lg" value={filters.course_id} onChange={(e) => setFilters({ ...filters, course_id: e.target.value })}>
              <option value="">All Courses</option>
            </select>
          </div>
          <div className="flex items-end">
            <button className="w-full bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700">Generate Report</button>
          </div>
        </div>
      </div>

      <div className="bg-white rounded-lg shadow p-8 text-center">
        <FileText className="h-16 w-16 text-gray-400 mx-auto mb-4" />
        <p className="text-gray-500">No exam report data available. Select filters to generate report.</p>
      </div>
    </div>
  );
};

export default ExamReport;